const HERO_VIDEO_SELECTOR = '.hero .hero__video';

function activateFallback(video) {
  const wrapper = video.closest('.hero__video-wrapper--desktop, .hero__video-wrapper--mobile');
  if (!wrapper) return;

  if (!wrapper.querySelector('.hero__video-fallback')) return;

  wrapper.classList.add('hero__video-wrapper--fallback');
  video.pause();
}

function attemptAutoplay(video) {
  if (video.dataset.heroAutoplayChecked === 'true') return;
  video.dataset.heroAutoplayChecked = 'true';

  const playPromise = video.play();

  if (playPromise && typeof playPromise.then === 'function') {
    playPromise.catch(() => {
      activateFallback(video);
    });
    return;
  }

  // Older browsers may not return a play promise.
  window.setTimeout(() => {
    if (video.paused) activateFallback(video);
  }, 200);
}

function bindVideo(video) {
  if (video.dataset.heroFallbackBound === 'true') return;
  video.dataset.heroFallbackBound = 'true';

  if (video.readyState >= 2) {
    attemptAutoplay(video);
  } else {
    video.addEventListener(
      'canplay',
      () => {
        attemptAutoplay(video);
      },
      { once: true },
    );
  }
}

function initHeroVideoFallback(root = document) {
  root.querySelectorAll(HERO_VIDEO_SELECTOR).forEach(bindVideo);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeroVideoFallback());
} else {
  initHeroVideoFallback();
}

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  initHeroVideoFallback(event.target);
});
